import { Reducer } from "redux";

import {
    BLOGS_ALBUM_DETAIL_FETCH_FAILURE,
    BLOGS_ALBUM_DETAIL_FETCH_REQUEST,
    BLOGS_ALBUM_DETAIL_FETCH_SUCCESS,
    BlogsAlbumDetailFetchFailureAction,
    BlogsAlbumDetailFetchRequestAction,
    BlogsAlbumDetailFetchSuccessAction,
} from "@/mk2/apps/blogs/containers/BlogsAlbumDetail/BlogsAlbumDetail.actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface BlogsAlbumDetailState {
    errorMessage: string;
    loadingState: LoadingState;
    postId: number;
    commentIds: number[];
}

export const initialBlogsAlbumDetailState: BlogsAlbumDetailState = {
    errorMessage: null,
    loadingState: LoadingState.INIT,
    postId: null,
    commentIds: [],
};

const stateKey = (action: BlogsAlbumDetailReducerAction) => `${action.username}/${action.postSlug}`;

export interface BlogsAlbumDetailPagesState {
    [key: string]: BlogsAlbumDetailState;
}

const initialBlogsAlbumDetailPagesState: BlogsAlbumDetailPagesState = {};

declare type BlogsAlbumDetailReducerAction =
    | BlogsAlbumDetailFetchRequestAction
    | BlogsAlbumDetailFetchSuccessAction
    | BlogsAlbumDetailFetchFailureAction;

const blogsAlbumDetailReducer: Reducer<BlogsAlbumDetailPagesState> = (
    state = initialBlogsAlbumDetailPagesState,
    action: BlogsAlbumDetailReducerAction,
) => {
    switch (action.type) {
        case BLOGS_ALBUM_DETAIL_FETCH_REQUEST:
        case BLOGS_ALBUM_DETAIL_FETCH_FAILURE: {
            const key = stateKey(action);
            return tupdate(state, {
                [key]: tupdate(state[key] || initialBlogsAlbumDetailState, {
                    errorMessage: errorMessage(undefined, action),
                    loadingState: loadingState(undefined, action),
                }),
            });
        }

        case BLOGS_ALBUM_DETAIL_FETCH_SUCCESS: {
            const key = stateKey(action);
            return tupdate(state, {
                [key]: tupdate(state[key] || initialBlogsAlbumDetailState, {
                    errorMessage: errorMessage(undefined, action),
                    loadingState: loadingState(undefined, action),
                    postId: action.response.result.post,
                }),
            });
        }

        default:
            return state;
    }
};

export default blogsAlbumDetailReducer;
